export class CreditLogsModel {
    constructor() {
    }
    ID: string;
    PhoneNumberName: string;
    PhoneNumber: string;
    NoramlCredits: number | string;
    NoramlAddOnCredits: number;
    NoramlCreditsUsed: number;
    NoramlCreditsLeft: number | string;
    GroupCredits: number | string;
    GroupAddOnCredits: number;
    GroupCreditsUsed: number;
    GroupCreditsLeft: number | string;
    SmsSent: number;
    MmsSent: number;
    GroupSMSSent: number;
    GroupMMSSent: number;
    SmsReceived: number;
    MmsReceived: number;
}

export const mapToCreditsLogs = (x: any): CreditLogsModel => {
    return {
        ID: x.phoneNumber,
        PhoneNumberName: x.phoneNumberName,
        PhoneNumber: x.phoneNumber,
        NoramlCredits: x.noramlCredits < 0 || x.noramlCredits === "Invalid Number" ? "Unlimited" : x.noramlCredits,
        NoramlAddOnCredits: x.noramlAddOnCredits,
        NoramlCreditsUsed: x.noramlCreditsUsed,
        NoramlCreditsLeft: x.noramlCreditsLeft < 0 || x.noramlCreditsLeft === "Invalid Number" ? "Unlimited" : x.noramlCreditsLeft,
        GroupCredits: x.groupCredits < 0 ? "Unlimited" : x.groupCredits,
        GroupAddOnCredits: x.groupAddOnCredits,
        GroupCreditsUsed: x.groupCreditsUsed,
        GroupCreditsLeft: x.groupCreditsLeft < 0 ? "Unlimited" : x.groupCreditsLeft,
        SmsSent: x.smsSent,
        MmsSent: x.mmsSent,
        GroupSMSSent: x.groupSMSSent,
        GroupMMSSent: x.groupMMSSent,
        SmsReceived: x.smsReceived,
        MmsReceived: x.mmsReceived
    } as CreditLogsModel
}
